import AppConfig from "@/_config/application-config"
import childRoutes from "@/apps/risk-assessment/routes/index.js"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const namespace = "riskassessment"
const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Risk-Assessment",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-alpha-r-circle-outline",
  parentRoute: "/risk-assessment",
  accentColor: "red",
  childRoutes,
  defaultRoute: "rahome",
  component: () => import( /* webpackChunkName: "home-parent" */ "@/apps/risk-assessment/Application.vue"),
  settings: {
  //  // domainName : "alignedautomation.com",
  //    domainName : "lyondellbasell.com",
  //   //baseUrl : "https://as-gpuriskapi-uat.azurewebsites.net/api/", // UAT
  //   baseUrl : "https://risk-assessment-api.azurewebsites.net/api/", // Dev
  //   //baseUrl :" https://api.nonprd.lyb.com/external/risk-assessment-stg/api/",
  //   client_id: "7f120ee0-461e-411d-bd6c-793c066181da",
  //   scope:"api://7f120ee0-461e-411d-bd6c-793c066181da/Read.All",
  //   authorizeUrl:
  //     "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
  //   tokenUrl:
  //     "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
  //   logoutUrl:
  //     "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://gpuriskassessment-stg.lyondellbasell.com",
   
    domainName : "alignedautomation.com",
    // domainName : "lyondellbasell.com",
    //baseUrl : "https://as-gpuriskapi-uat.azurewebsites.net/api/", // UAT
    baseUrl : "https://risk-assessment-api.azurewebsites.net/api/", // Dev
    //baseUrl :" https://api.nonprd.lyb.com/external/risk-assessment-stg/api/",
    client_id: "70b7c766-5ff7-45a6-a88f-4d2cbea7353c",
    scope:"api://70b7c766-5ff7-45a6-a88f-4d2cbea7353c/70b7c766-5ff7-45a6-a88f-4d2cbea7353c",
    authorizeUrl:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/authorize",
    tokenUrl:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/token",
    logoutUrl:
      "https://login.microsoftonline.com/3dcd35b5-f9c5-48ca-8653-821568ad3397/oauth2/v2.0/logout?post_logout_redirect_uri=https://risk-assessment-web.azurewebsites.net/#/risk-assessment/logout",
    redirect_uri: window.location.origin, //Gets the current  
    autologin: true,
    debug: false,
    currentTime: null,
    currentTimeInterval: null,
    azure_deployed: 1,
    navigation: [
      // {
      //   icon: "mdi-home",
      //   text: "Home",
      //   link: "/risk-assessment/rahome",
      //   roles: [ "Admin"],
      // },

      {
        icon: "mdi-view-grid",
        text: "RM Risk Assessment",
        link: "/risk-assessment/rmgrid",
        roles: [ "RM User","RM Viewer","RM Admin"],
        items: [
          {
            icon: "mdi-file-document-multiple",
            text: "RM Risk Summary Matrix",
            link: "/risk-assessment/summary",
            roles:["RM Admin","RM User","RM Viewer"]
          },
          {
            icon: "mdi-view-grid",
            text: "RM Risk Assessment",
            link: "/risk-assessment/rmview",
            roles:["RM Admin","RM User","RM Viewer"]
            
          },
          {
            icon: "mdi-view-grid",
            text: "RM Risk Mitigation One Pager",
            link: "/risk-assessment/rmmaterialriskmitigation",
            roles:["RM Admin","RM User","RM Viewer"]        
          },
          {
            icon: "mdi-view-grid",
            text: "RM Risk Mitigation One Pager (PBAU)",
            link: "/risk-assessment/rmmaterialriskmitigationpbau",
            roles:["RM Admin","RM User","RM Viewer"]
          },      
          {
            icon: "mdi-floor-plan",
            text: "RM Action Plan",
            link: "/risk-assessment/actionplan",
            roles:["RM Admin","RM User","RM Viewer"]      
          },
          {
            icon: "mdi-monitor-dashboard",
            text: "RM Action Plan Dashboard",
            link: "/risk-assessment/actionplanDashboard",
            roles:["RM Admin","RM User","RM Viewer"]
          },
        ]
      },     

      {
        icon: "mdi-application-cog",
        text: "RM Admin Module",
        link: "/risk-assessment/rmadmin",
        roles: [ 'RM Admin'],
        items: [
          {
            icon: "mdi-account-multiple",
            text: "User Management",
            link: "/risk-assessment/users",
            roles: [ "RM Admin"]
          },
          {
            icon: "mdi-account-group",
            text: "Material Group Owner Mapping",
            link: "/risk-assessment/owners",
            roles: [ "RM Admin"]
          },
          {
            icon: "mdi-file-table-box-outline",
            text: "Risk Assessment Master",
            link: "/risk-assessment/riskAssessment",
            roles: [ "RM Admin"]
          },
          {
            icon: "mdi-file-table-box-outline",
            text: "Risk Rating Master",
            link: "/risk-assessment/riskRating",
            roles: [ "RM Admin"]
          }
        ]
      },

      {
        icon: "mdi-view-grid",
        text: "TSM Risk Assessment",
        link: "/risk-assessment/tsmgrid",
        roles: [ 'TS User','TS Viewer','TM User','TM Viewer','TS Admin','TM Admin','TS Supplier','TM Supplier'],
        items: [
          {
            icon: "mdi-file-document-multiple",
            text: "TS/TM Risk Summary Matrix",
            link: "/risk-assessment/tstmsummary",
            roles:["TS Admin","TS User","TS Viewer","TM Admin","TM User","TM Viewer"]
          },
          {
            icon: "mdi-view-grid",
            text: "TS Assessment GRID",
            link: "/risk-assessment/tsview",
            roles:["TS Admin","TS User","TS Viewer"]
          },
          {
            icon: "mdi-floor-plan",
            text: "TS Action Plan",
            link: "/risk-assessment/tsactionplan",
            roles:["TS Admin","TS User","TS Viewer"]
          },
          {
            icon: "mdi-view-grid",
            text: "TM Assessment GRID",
            link: "/risk-assessment/tmview",
            roles:["TM Admin","TM User","TM Viewer"]
          },
          {
            icon: "mdi-floor-plan",
            text: "TM Action Plan",
            link: "/risk-assessment/tmactionplan",
            roles:["TM Admin","TM User","TM Viewer"]
          },      
          {
            icon: "mdi-file-document-multiple",
            text: "Supplier Input Form",
            link: "/risk-assessment/supplierinputform",
            roles:["TS Supplier","TM Supplier","TS Admin","TM Admin"]
          },
          {
            icon: "mdi-file-document-multiple",
            text: "Supply Chain Risk Watch",
            link: "/risk-assessment/supplychainriskwatch",
            roles:["TS Admin","TS User","TS Viewer","TM Admin","TM User","TM Viewer"]
          },
          {
            icon: "mdi-file-document-multiple",
            text: "Segment Risk One Pager",
            link: "/risk-assessment/segmentriskonepager",
            roles:["TS Admin","TS User","TS Viewer","TM Admin","TM User","TM Viewer"]
          },
        ]
      },
      
      {
        icon: "mdi-application-cog",
        text: "TSM Admin Module",
        link: "/risk-assessment/tsmadmin",
        roles: [ "TS Admin","TM Admin"],
        items: [
          {
            icon: "mdi-account-multiple",
            text: "User Management",
            link: "/risk-assessment/tsmusers",
            roles: [ "TS Admin","TM Admin"],
          },
          {
            icon: "mdi-delete-restore",
            text: "Deleted Records",
            link: "/risk-assessment/deletedrecords",
            roles: [ "TS Admin","TM Admin"],
          },
          {
            icon: "mdi-file-table-box-outline",
            text: "Segment/Commodity Master",
            link: "/risk-assessment/segmentcommoditymaster",
            roles: [ "TS Admin","TM Admin"],
          },
          {
            icon: "mdi-file-table-box-outline",
            text: "Supplier Master",
            link: "/risk-assessment/suppliermaster",
            roles: [ "TS Admin","TM Admin"],
          },
          {
            icon: "mdi-file-table-box-outline",
            text: "Risk Parameters Mapping",
            link: "/risk-assessment/segmentOneMapping",
            roles: [ "TS Admin","TM Admin"],
          },         
        ]
      },


// CS-IT Risk Assessment  
      {
        icon: "mdi-view-grid",
        text: "CS-IT Risk Assessment",
        link: "/risk-assessment/csitview",
        roles: ["CSIT Admin","CSIT Viewer","CSIT CategoryUser","CSIT Category User-Restricted"],
        items: [          
          {
            icon: "mdi-file-document-multiple",
            text: "CS-IT Summary Matrix",
            link: "/risk-assessment/csitsummary",
            roles: ["CSIT Admin","CSIT Viewer","CSIT CategoryUser","CSIT Category User-Restricted"],
          },
          {
            icon: "mdi-view-grid",
            text: "CS-IT Risk Assessment",
            link: "/risk-assessment/csitview",
            roles: ["CSIT Admin","CSIT Viewer","CSIT CategoryUser"],
          },
          {
            icon: "mdi-floor-plan",
            text: "CS-IT Action Plan",
            link: "/risk-assessment/csitactionplan",
            roles: ["CSIT Admin","CSIT Viewer","CSIT CategoryUser"],
          },
          {
            icon: "mdi-view-grid",
            text: "Consulting Risk Assessment",
            link: "/risk-assessment/consultingassessmentview",
            roles: ["CSIT Admin","CSIT Viewer","CSIT Category User-Restricted"],
          },
          {
            icon: "mdi-floor-plan",
            text: "Consulting Action Plan",
            link: "/risk-assessment/consultingactionplan",
            roles: ["CSIT Admin","CSIT Viewer","CSIT Category User-Restricted"],
          },
          {
            icon: "mdi-file-document-multiple",
            text: "Segment One Pager",
            link: "/risk-assessment/csitsegmentonepager",
            roles: ["CSIT Admin","CSIT Viewer","CSIT CategoryUser","CSIT Category User-Restricted"],
          },
        ]
      },
      // CS-IT Risk Assessment | Admin Module
      {
        icon: "mdi-application-cog",
        text: "CS-IT Admin Module",
        link: "/risk-assessment/csitadmin",
        roles: [ "CSIT Admin"],
        items: [{
          icon: "mdi-account-multiple",
          text: "User Management",
          link: "/risk-assessment/csitusers",
          roles: ["CSIT Admin"],
        },{
          icon: "mdi-delete-restore",
          text: "Deleted Records",
          link: "/risk-assessment/csitdeleterecords",
          roles: ["CSIT Admin"],
        },{
          icon: "mdi-file-table-box-outline",
          text: "Segment Master",
          link: "/risk-assessment/csitsegmentmaster",
          roles: ["CSIT Admin"],
        },{
          icon: "mdi-file-table-box-outline",
          text: "Risk Parameters Mapping",
          link: "/risk-assessment/riskparametersmapping",
          roles: [ "CSIT Admin"],
        }]
      },
      
    ],
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor : {
      default: "red",
      storageMode : localStorage,
    },
    isTrue : {
      default: true,
      storageMode : sessionStorage,
    },
  }

}

export default AppConfig.merge(appConfig);

